export const config = {
  apiKey: "AIzaSyALv5ON0zQyTvAAYDPK9SqZo6TRTReNeXg",
  authDomain: "rtld-29ac1.firebaseapp.com",
  databaseURL: "https://rtld-29ac1.firebaseio.com",
  projectId: "rtld-29ac1",
  storageBucket: "rtld-29ac1.appspot.com",
  messagingSenderId: "677604072405",
  appId: "1:677604072405:web:33d4ac2416ffbc724abb5c",
  measurementId: "G-71CQJLKH8L"
};
